import React, { useEffect, useState } from 'react';
import { DashboardLayout } from '@shared/infrastructure/ui/layout/dashboardLayout';
import { userRepository } from '@shared/domain/user/user.repository';
import { User } from '@shared/domain/user/user.aggregate';
import {
  TablePlain,
  TableCell,
  TableRow
} from '@shared/infrastructure/ui/components/table/tablePlain/tablePlain';
import { PageHeader } from '@shared/infrastructure/ui/components/header/pageHeader';

export const UsersView = () => {
  const [users, setusers] = useState<User[]>([]);
  useEffect(() => {
    userRepository.getUsers().then(setusers);
  }, []);

  return (
    <DashboardLayout>
      <PageHeader>
        <>Users View</>
      </PageHeader>
      <TablePlain<User[]> data={users} headers={['Name', 'Email']}>
        {(data: User[]) =>
          data.map((user: User) => (
            <TableRow
              key={user.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              aria-label='user table row'
            >
              <TableCell component='th' scope='row'>
                {user.name}
              </TableCell>
              <TableCell>{user.email} </TableCell>
            </TableRow>
          ))
        }
      </TablePlain>
    </DashboardLayout>
  );
};
